import Swal from "sweetalert2";

export default function Alert(i18n) {

    this.timer = 2000;
    this.position = "center";

    this.success = function(messages) {
        Swal.fire({
        position: this.position,
        icon: "success",
        title: messages,
        showConfirmButton: false,
        timer: this.timer
        });
    };

    this.error = function(messages) {
        Swal.fire({
        position: this.position,
        icon: "error",
        title: messages,
        showConfirmButton: false,
        timer: this.timer
        });
    };

    this.info = function(messages) {
        Swal.fire({
        position: this.position,
        icon: "info",
        title: messages,
        showConfirmButton: false,
        timer: this.timer
        });
    };

    this.warning = function(messages) {
        Swal.fire({
        position: this.position,
        icon: "warning",
        title: messages,
        showConfirmButton: false,
        timer: this.timer
        });
    };

    this.confirm = function(messages, callback) {
        Swal.fire({
        text: messages,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.global.t('basic.btn.yes'),
        cancelButtonText: i18n.global.t('basic.btn.no'),
        }).then(callback);
    };
}